import {DateTime} from "luxon";

export type ZoomElement = {
    x: DateTime[],
    y: number[]
}

const zoomEquals = (a: ZoomElement, b: ZoomElement) : boolean => {
    return a.x.length === b.x.length && a.y.length === b.y.length &&
        a?.x[0]?.equals(b?.x[0]) &&
        a?.x[1]?.equals(b?.x[1]) &&
        a?.y[0] === (b?.y[0]) &&
        a?.y[1] === (b?.y[1]);
}

export {zoomEquals}